/**
 * TransactionReportsCtrl controller
 *
 */

/* @ngInject */
export default function TransactionReportsCtrl ($scope, $window, authSvc) {
  var vm = this

  // backward compatible: если прав на transaction ещё нет, разрешаем через financial
  vm.mixes = authSvc.hasAccess('createTransactionReport')
    ? [['tabsCtrlMixin', '', 'reports_list', 'generated_reports']]
    : [['tabsCtrlMixin', 'reports_list', 'generated_reports']]

  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
